import React from "react";
import Navbar from "../components/Navbar";

export default function Privacy() {
  return (
    <div className="min-h-screen bg-[#05050a] text-white">
      <Navbar />
      <main className="max-w-3xl mx-auto px-4 sm:px-6 py-10" data-testid="privacy-page">
        <div className="font-mono-cosmic text-[10px] tracking-[0.3em] uppercase text-[#00ffff] mb-2">
          // LEGAL · PRIVACY
        </div>
        <h1 className="font-heading text-4xl sm:text-5xl mb-2">Privacy Policy</h1>
        <div className="font-mono-cosmic text-[10px] tracking-[0.25em] uppercase text-white/45 mb-8">
          Last updated · 2026-05-27
        </div>

        <section className="space-y-6 text-white/80 leading-relaxed">
          <p>
            Cosmic Worm Breaker ("we", "our", "the game") is operated as a web app.
            This page explains what data we collect, why, and how to control it.
            We do not sell your personal data. Ever.
          </p>

          <div>
            <h2 className="font-heading text-xl mb-2 text-white">1. Data we collect</h2>
            <ul className="list-disc list-inside space-y-1 text-sm">
              <li><b>Account</b> — email + pilot callsign, stored to identify you across sessions and devices.</li>
              <li><b>Gameplay</b> — levels cleared, scores, achievements, daily/endless runs, cosmetic purchases.</li>
              <li><b>Payments</b> — handled by Stripe. We never see or store your card details. Stripe returns a session ID we link to your account.</li>
              <li><b>Analytics</b> — install attribution (?src= referrers), crash logs, anonymous gameplay telemetry to fix bugs.</li>
              <li><b>Notifications</b> — push subscription endpoint (only if you opt in) so we can send streak reminders.</li>
            </ul>
          </div>

          <div>
            <h2 className="font-heading text-xl mb-2 text-white">2. How we use it</h2>
            <ul className="list-disc list-inside space-y-1 text-sm">
              <li>Authenticate your account and persist your progress.</li>
              <li>Process cosmetic purchases via Stripe (no real-money cashout, no gambling).</li>
              <li>Render leaderboards using only your callsign (never your email).</li>
              <li>Debug crashes and improve performance — aggregate, never sold.</li>
            </ul>
          </div>

          <div>
            <h2 className="font-heading text-xl mb-2 text-white">3. Sharing</h2>
            <p className="text-sm">
              We share data with: <b>Stripe</b> (payments), <b>MongoDB Atlas</b> (database hosting),
              and the hosting platform we run on. Public leaderboards display callsign + score only —
              never your email or location.
            </p>
          </div>

          <div>
            <h2 className="font-heading text-xl mb-2 text-white">4. Your rights</h2>
            <ul className="list-disc list-inside space-y-1 text-sm">
              <li><b>Access / Export</b> — email <a href="mailto:privacy@cosmic.space" className="text-[#00ffff] underline">privacy@cosmic.space</a> and we'll send your data in JSON within 30 days.</li>
              <li><b>Delete</b> — same email, subject "Delete my account". We wipe your row + all linked progress/cosmetics within 30 days.</li>
              <li><b>Opt out of push</b> — toggle off in browser settings or our in-app Notifications page.</li>
            </ul>
          </div>

          <div>
            <h2 className="font-heading text-xl mb-2 text-white">5. Cookies</h2>
            <p className="text-sm">
              We use one cookie pair (<code className="text-[#00ffff] text-xs">access_token</code> + <code className="text-[#00ffff] text-xs">refresh_token</code>)
              for login. They are HTTP-only, SameSite=Lax, and used solely to keep you signed in. No tracking cookies, no third-party ad pixels.
            </p>
          </div>

          <div>
            <h2 className="font-heading text-xl mb-2 text-white">6. Children</h2>
            <p className="text-sm">
              Not directed at children under 13. If you believe a child has created an account, email us and we'll delete it.
            </p>
          </div>

          <div>
            <h2 className="font-heading text-xl mb-2 text-white">7. Changes</h2>
            <p className="text-sm">
              We'll bump the "Last updated" date at the top whenever this policy changes. Material changes will surface as an in-app notification.
            </p>
          </div>

          <div>
            <h2 className="font-heading text-xl mb-2 text-white">8. Contact</h2>
            <p className="text-sm">
              Privacy questions: <a href="mailto:privacy@cosmic.space" className="text-[#00ffff] underline">privacy@cosmic.space</a>.
            </p>
          </div>
        </section>
      </main>
    </div>
  );
}
